/** Normalize values for <input type="date"> (avoid timezone shifts on date-only strings). */
export function toDateInputValue(value) {
  if (!value) {
    return "";
  }

  if (typeof value === "string") {
    const normalized = value.trim();
    const dateOnlyMatch = normalized.match(/^(\d{4}-\d{2}-\d{2})/);
    if (dateOnlyMatch) {
      return dateOnlyMatch[1];
    }
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/** Local calendar date as YYYY-MM-DD (for comparisons). */
export function todayIsoDate() {
  const n = new Date();
  const y = n.getFullYear();
  const mo = String(n.getMonth() + 1).padStart(2, "0");
  const d = String(n.getDate()).padStart(2, "0");
  return `${y}-${mo}-${d}`;
}

/** YYYY-MM-DD or null when unset. */
export function toIsoDateOrNull(value) {
  const s = toDateInputValue(value);
  return s || null;
}

const ORDER_DATE_CHAIN_KEYS = ["dateIn", "workStarted", "workCompleted", "dateOut"];

/**
 * Ensures filled milestone dates are non-decreasing in workflow order.
 * @param {Record<string, unknown>} fields — order-like object with date fields
 * @returns {string | null} Error message, or null if valid
 */
export function validateOrderDateChain(fields) {
  if (!fields) {
    return null;
  }
  const sequence = [];
  for (const key of ORDER_DATE_CHAIN_KEYS) {
    const iso = toIsoDateOrNull(fields[key]);
    if (iso) {
      sequence.push(iso);
    }
  }
  for (let i = 1; i < sequence.length; i += 1) {
    if (sequence[i] < sequence[i - 1]) {
      return "Dates must follow order: Date in → Work started → Work completed → Date out.";
    }
  }
  return null;
}
